import { Pipe, PipeTransform } from '@angular/core';
import { CustomerDto } from '@careapp-group/ng-sdk';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { distinct, map } from 'rxjs/operators';
import { CUSTOMERS, getEntities } from '../../store';

@Pipe({
    name: 'customersFromIds',
    pure: true,
    standalone: false
})
export class CustomersFromIdsPipe implements PipeTransform {
  constructor(private store: Store<any>) {}
  public transform(data: string[]): Observable<CustomerDto[]> {
    if (!data || !Array.isArray(data)) {
      return of<CustomerDto[]>([]);
    }
    return this.store.select(getEntities(CUSTOMERS)).pipe(
      map((customerEntities: { [key: string]: CustomerDto }) =>
        data
          .filter((customerId) => !!customerEntities[customerId])
          .map((customerId) => customerEntities[customerId])
      ),
      distinct()
    );
  }
}
